import { setCookie } from '../../mixins/cookie';
import { addQueryArgs } from '@wordpress/url';
import { getCompareCookie } from './toggle-compare';

const compareBoxNode = document.querySelector( '.realpress-compare-box' );
let restUrl, restNamespace;

const realpressCompareList = () => {
	if ( ! compareBoxNode ) {
		return;
	}

	restUrl = REALPRESS_GLOBAL_OBJECT.rest_url || '';
	restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';

	fetchProperties();
	removeProperty();
};

const fetchProperties = () => {
	compareBoxNode.style.opacity = 0.4;
	fetch( addQueryArgs( restUrl + restNamespace + '/compare' ), { method: 'GET' } )
		.then( ( res ) => res.json() )
		.then( ( res ) => {
			if ( res.data.content ) {
				compareBoxNode.innerHTML = res.data.content;
			}
		} ).catch( ( err ) => {
			console.log( err );
		} ).finally( () => {
			compareBoxNode.style.opacity = 1;
		} );
};

const removeProperty = () => {
	document.addEventListener( 'click', function( event ) {
		const target = event.target;
		const removeNode = target.closest( '.remove' );
		if ( removeNode && compareBoxNode.contains( target ) ) {
			let propertyId = removeNode.getAttribute( 'data-property-id' );
			if ( propertyId ) {
				propertyId = parseInt( propertyId );
			}

			let propertyIds = getCompareCookie();
			if ( propertyIds.includes( propertyId ) ) {
				propertyIds = propertyIds.filter( ( item ) => item !== propertyId );
				setCookie( 'realpress_compare_property', propertyIds.join( ',' ), 30 );
				fetchProperties();
			}
		}
	} );
};

export default realpressCompareList;
